import { useParams } from "react-router-dom";
import PropertyWizard from "../pages/PropertyWizard";

function EditProperty() {

const { id } = useParams();

return (
<PropertyWizard
mode="edit"
propertyId={id}
/>
);

}

export default EditProperty;